import {TimelineLite, TweenLite} from "gsap";
import {Layers, TheRaveLayers} from "./TheRaveLayers";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TheRaveReelView} from "../reels/TheRaveReelView";

export class FullScreenDimLayer extends PIXI.Container {

    private _dimmer: PIXI.Sprite;
    private _reelAreaDimmer: PIXI.Sprite;

    constructor() {
        super();
        this._dimmer = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._dimmer.name = "fullScreenDimmer";
        this._dimmer.tint = 0x000000;
        this._dimmer.alpha = 0;
        this._dimmer.visible = false;
        this._dimmer.anchor.set(0.5, 0.5);
        this._dimmer.position.set(360, 360);
        this._dimmer.width = NolimitApplication.screenBounds.width;
        this._dimmer.height = NolimitApplication.screenBounds.height;
        this.addChild(this._dimmer);

        this._reelAreaDimmer = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._reelAreaDimmer.name = "reelAreaDimmer";
        this._reelAreaDimmer.width = TheRaveReelView.REEL_WIDTH;
        this._reelAreaDimmer.height = TheRaveReelView.REEL_HEIGHT;
        this._reelAreaDimmer.position.set(TheRaveReelView.REEL_LEFT-TheRaveReelView.SYMBOL_WIDTH*0.5, TheRaveReelView.REEL_TOP);
        this._reelAreaDimmer.anchor.set(0, 0);
        this._reelAreaDimmer.tint = 0x000000;
        this._reelAreaDimmer.alpha = 0;
        this._reelAreaDimmer.visible = false;

        TheRaveLayers.getLayer(Layers.REEL_AREA_DIMMER)!.addChild(this._reelAreaDimmer);
        TheRaveLayers.getLayer(Layers.WIN_PRESENTATIONS)!.addChild(this);
    }

    public startReelAreaDimmer(toAlpha:number = 0.4): TweenLite {
        if(this._reelAreaDimmer.visible){
            return TweenLite.to(this._reelAreaDimmer, {alpha: 0.4, duration: 0});
        }
        this._reelAreaDimmer.width = TheRaveReelView.REEL_WIDTH;
        this._reelAreaDimmer.height = TheRaveReelView.REEL_HEIGHT;
        this._reelAreaDimmer.alpha = 0;
        this._reelAreaDimmer.visible = true;
        return TweenLite.to(this._reelAreaDimmer, {alpha: toAlpha, duration: 0.2});
    }

    public stopReelAreaDimmer(): TimelineLite {
        if(!this._reelAreaDimmer.visible){
            return new TimelineLite();
        }
        return new TimelineLite()
            .add(TweenLite.to(this._reelAreaDimmer, {alpha: 0, duration: 0.2}))
            .add(()=> {this._reelAreaDimmer.visible = false});
    }


    public start(fadeOutScreenDuration:number = 0.5): TweenLite {
        if(this._dimmer.visible){
            return TweenLite.to(this._dimmer, {alpha: 0.5, duration: 0});
        }
        this._dimmer.alpha = 0;
        this._dimmer.visible = true;
        this._dimmer.width = NolimitApplication.screenBounds.width;
        this._dimmer.height = NolimitApplication.screenBounds.height;
        return TweenLite.to(this._dimmer, {alpha: 0.5, duration: fadeOutScreenDuration-0.1});
    }

    public stop(): TimelineLite {
        if(!this._dimmer.visible){
            return new TimelineLite();
        }
        return new TimelineLite()
            .add(TweenLite.to(this._dimmer, {alpha: 0, duration: 0.4}))
            .add(()=> {this._dimmer.visible = false});
    }

    public onOrientationChanged():void {
        if (this._dimmer.visible) {
            this._dimmer.width = NolimitApplication.screenBounds.width;
            this._dimmer.height = NolimitApplication.screenBounds.height;
        }
    }
}